module.exports = __webpack_public_path__ + "pm.svg?18b13303fd19cc59a3e726ea0ba69bab";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pm.svg
// module id = 1106
// module chunks = 27